import { render, staticRenderFns } from "./TabDropdown.vue?vue&type=template&id=4fbe73f2&scoped=true&"
import script from "./TabDropdown.vue?vue&type=script&lang=js&"
export * from "./TabDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TabDropdown.vue?vue&type=style&index=0&id=4fbe73f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe73f2",
  null
  
)

export default component.exports